import { render, staticRenderFns } from "./examinetaskmain.vue?vue&type=template&id=bde6ebda&"
import script from "./examinetaskmain.vue?vue&type=script&lang=js&"
export * from "./examinetaskmain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports